import Vue from "vue";
import Vuex from "vuex";

import chartData from "./modules/chart-data";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: true
  },
  getters: {
    isLoading: state => state.isLoading
  },
  mutations: {
    commitIsLoading: (state, isLoading) => {
      state.isLoading = isLoading;
    }
  },
  actions: {
    setIsLoading: (context, isLoading) =>
      context.commit("commitIsLoading", isLoading)
  },

  modules: {
    chartData
  }
});
